const styles = {
  // Container utilities
  boxWidth: "w-full px-4 mx-auto sm:px-6 md:px-8 lg:px-10 xl:max-w-[1280px]",
  containerPadding: "px-4 sm:px-6 md:px-8 lg:px-10",

  // Flex layouts
  flexCenter: "flex justify-center items-center",
  flexStart: "flex justify-start items-start",
  flexBetween: "flex justify-between items-center",
  flexCol: "flex flex-col",

  // Grid layouts
  gridAuto: "grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4",

  // Spacing system
  spacing: {
    xs: "gap-2", // 8px
    sm: "gap-4", // 16px
    md: "gap-6", // 24px
    lg: "gap-8", // 32px
    xl: "gap-10", // 40px
  },

  // Padding utilities
  paddingX: "px-4 sm:px-6 md:px-8 lg:px-10",
  paddingY: "py-4 sm:py-6 md:py-8 lg:py-10",
  padding: "p-4 sm:p-6 md:p-8 lg:p-10",

  // Margin utilities
  marginX: "mx-4 sm:mx-6 md:mx-8 lg:mx-10",
  marginY: "my-4 sm:my-6 md:my-8 lg:my-10",

  // Button sizes
  btnMin: "min-w-[44px] min-h-[44px] sm:min-w-[48px] sm:min-h-[48px]",

  // Typography
  heading1: "text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold",
  heading2: "text-xl sm:text-2xl md:text-3xl lg:text-4xl font-semibold",
  paragraph: "text-base sm:text-lg leading-relaxed",

  // Responsive button for summary/context bar
  responsiveSummaryBtn:
    "w-full rounded-xl px-3 py-2 sm:py-3 sm:px-4 shadow-sm bg-primary flex flex-col items-start justify-between gap-1 min-h-[44px] sm:min-h-[48px]",
};

export const layout = {
  section: `flex flex-col md:flex-row ${styles.paddingY}`,
  sectionReverse: `flex flex-col-reverse md:flex-row ${styles.paddingY}`,
  sectionImgReverse: `flex-1 flex ${styles.flexCenter} md:mr-10 mr-0 md:mt-0 mt-10 relative`,
  sectionImg: `flex-1 flex ${styles.flexCenter} md:ml-10 ml-0 md:mt-0 mt-10 relative`,
  sectionInfo: `flex-1 ${styles.flexStart} flex-col`,
};

export default styles;
